import React, { Fragment } from 'react';
import { Field } from 'redux-form';

import Input from '~COMPONENTS/formInputs/Input';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import {
  handleValidatePrePack,
  hasValueAndIsPositive,
  validateMinRules,
  validateMaxRules,
  lessThanAvailable,
  isNotZero
} from '~APP_UTIL/formValidations';
import { PDP_QUANTITY_MAXLEN } from '../constants';

export default [
  {
    header: (
      <>
        <TranslatedCopy id='global.size' />:
      </>
    ),
    id: 'displaySize',
    cell: ({ displaySize }, { isFtwr }) => {
      return isFtwr ? (
        <div className='ftwr-size-conversion-div'>
          <span className='ftwr-size-conversion-span'>{displaySize}</span>
        </div>
      ) : (
        displaySize
      );
    }
  },
  {
    header: (
      <>
        <TranslatedCopy id='global.quantity' />:
      </>
    ),
    id: 'quantity',
    cell: (size, { selectedProduct, total, min, max }) => (
      <Field
        name={`${size.sizeCode.split('.').join('_')}--${size.code}`}
        type='text'
        component={Input}
        validate={[
          hasValueAndIsPositive,
          lessThanAvailable,
          isNotZero,
          ...[
            handleValidatePrePack(selectedProduct),
            validateMinRules(min, total),
            validateMaxRules(max, total)
          ].filter(validation => validation)
        ]}
        available={size.quantity}
        disabled={size.quantity === '0'}
        maxLength={PDP_QUANTITY_MAXLEN}
      />
    )
  }
];
